module.exports = __webpack_public_path__ + "static/img/female-bg-id.92277806.png";